export const pokedexGen9 = {
  "pokedex906": "Felori",
  "pokedex907": "Feliospa",
  "pokedex908": "Maskagato",
  "pokedex909": "Krokel",
  "pokedex910": "Lokroko",
  "pokedex911": "Skelokrok",
  "pokedex912": "Kwaks",
  "pokedex913": "Fuentente",
  "pokedex914": "Bailonda",
  "pokedex915": "Forgita",
  "pokedex916": "Fragrunz",
  "pokedex917": "Tarundel",
  "pokedex918": "Spinsidias",
  "pokedex919": "Micrick",
  "pokedex920": "Lextremo",
  "pokedex921": "Pamo",
  "pokedex922": "Pamamo",
  "pokedex923": "Pamomamo",
  "pokedex924": "Zwieps",
  "pokedex925": "Famieps",
  "pokedex926": "Hefel",
  "pokedex927": "Backel",
  "pokedex928": "Olini",
  "pokedex929": "Olivenio",
  "pokedex930": "Olithena",
  "pokedex931": "Krawalloro",
  "pokedex932": "Geosali",
  "pokedex933": "Sedisal",
  "pokedex934": "Saltigant",
  "pokedex935": "Knarbon",
  "pokedex936": "Crimanzo",
  "pokedex937": "Azugladis",
  "pokedex938": "Blipp",
  "pokedex939": "Wampitz",
  "pokedex940": "Voltrel",
  "pokedex941": "Voltrean",
  "pokedex942": "Mobtiff",
  "pokedex943": "Mastifioso",
  "pokedex944": "Echtel",
  "pokedex945": "Schligdri",
  "pokedex946": "Adebom",
  "pokedex947": "Papungi",
  "pokedex948": "Tentagra",
  "pokedex949": "Tenterra",
  "pokedex950": "Klibbe",
  "pokedex951": "Chilingel",
  "pokedex952": "Halupenjo",
  "pokedex953": "Relluk",
  "pokedex954": "Skarabaks",
  "pokedex955": "Flattutu",
  "pokedex956": "Fontanestra",
  "pokedex957": "Brimano",
  "pokedex958": "Azugladis",
  "pokedex959": "Donnersichel",
  "pokedex960": "Schligda",
  "pokedex961": "Schligdri",
  "pokedex962": "Adebom",
  "pokedex963": "Normifin",
  "pokedex964": "Delfinator",
  "pokedex965": "Knattox",
  "pokedex966": "Knattatox",
  "pokedex967": "Mopex",
  "pokedex968": "Schlurm",
  "pokedex969": "Lumispross",
  "pokedex970": "Lumiflora",
  "pokedex971": "Gruff",
  "pokedex972": "Friedwuff",
  "pokedex973": "Flaminkno",
  "pokedex974": "Flaniwal",
  "pokedex975": "Kolowal",
  "pokedex976": "Agiluza",
  "pokedex977": "Heerashai",
  "pokedex978": "Nigiragi",
  "pokedex979": "Epitaff",
  "pokedex980": "Suelord",
  "pokedex981": "Farigiraf",
  "pokedex982": "Dummimisel",
  "pokedex983": "Gladimperio",
  "pokedex984": "Riesenzahn",
  "pokedex985": "Brüllschweif",
  "pokedex986": "Wutpilz",
  "pokedex987": "Flatterhaar",
  "pokedex988": "Kriechflügel",
  "pokedex989": "Sandfell",
  "pokedex990": "Eisenrad",
  "pokedex991": "Eisenbündel",
  "pokedex992": "Eisenhand",
  "pokedex993": "Eisenhals",
  "pokedex994": "Eisenfalter",
  "pokedex995": "Eisendorn",
  "pokedex996": "Frospino",
  "pokedex997": "Cryospino",
  "pokedex998": "Espinodon",
  "pokedex999": "Gierspenst",
  "pokedex1000": "Monetigo",
  "pokedex1001": "Chongjian",
  "pokedex1002": "Baojian",
  "pokedex1003": "Dinglu",
  "pokedex1004": "Yuyu",
  "pokedex1005": "Donnersichel",
  "pokedex1006": "Eisenkrieger",
  "pokedex1007": "Koraidon",
  "pokedex1008": "Miraidon",
  "pokedex1009": "Windewoge",
  "pokedex1010": "Eisenblatt",
  "pokedex1011": "Sirapfel",
  "pokedex1012": "Mortcha",
  "pokedex1013": "Fatalitcha",
  "pokedex1014": "Boninu",
  "pokedex1015": "Benesaru",
  "pokedex1016": "Beatori",
  "pokedex1017": "Ogerpon",
  "pokedex1018": "Briduradon",
  "pokedex1019": "Hydrapfel",
  "pokedex1020": "Keilflamme",
  "pokedex1021": "Furienblitz",
  "pokedex1022": "Eisenfels",
  "pokedex1023": "Eisenhaupt",
  "pokedex1024": "Terapagos",
  "pokedex1025": "Infamomo",
};